import { render, staticRenderFns } from "./BoxwrapHeaderItems.vue?vue&type=template&id=7e31aabf"
import script from "./BoxwrapHeaderItems.vue?vue&type=script&lang=js"
export * from "./BoxwrapHeaderItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports